module.exports = __webpack_public_path__ + "static/media/03.cc48cc44.png";